import React from 'react';
import { Box, Dialog, Divider, SvgIconProps } from '@mui/material';
import { useMessagingContext, useSelectedConversation } from '../MessagingProvider.component';
import { ConversationsList } from '../ConversationsSidebar/ConversationsList.component';
import { Color } from '../types';
import { Messages } from '../Messages';
import { ModalTitle } from '../../Modal';
import { Button } from '../../Button';
import { useIsMobile } from '@uplift/hooks';


export type MessagingModalProps = {
  color?: Color;
  onOpenToDosClick?: () => void;
};


export const DialogActionButton: React.FC<{
  onClick?: () => void;
  Icon: React.ElementType<SvgIconProps>;
}> = ({ children, onClick, Icon }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Button
        size="small"
        onClick={onClick}
      >
        <Icon color="action" />
      </Button>
    );
  }

  return (
    <Button
      size="small"
      onClick={onClick}
      startIcon={<Icon color="action" />}
    >
      {children}
    </Button>
  );
};


export const MessagingDialogTitle: React.VFC<{
  title: string;
  actions?: React.ReactNode;
}> = (props) => {
  const messaging = useMessagingContext();

  return (
    <ModalTitle
      onClose={messaging.closeModal}
      sx={props.actions ? {
        paddingLeft: {
          xs: '0 !important',
          sm: '16px !important'
        }
      } : {}}
    >
      <Box flex={1}>{props.actions}</Box>
      <span>
        {props.title}
      </span>
      <Box flex={1} />
    </ModalTitle>
  );
};


export const DesktopMessagingDialog: React.FC = ({ children }) => {
  const messaging = useMessagingContext();

  return (
    <Dialog
      data-testid="messaging-modal"
      open={messaging.modalOpened}
      onClose={messaging.closeModal}
      maxWidth="md"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            maxHeight: '80%',
            height: '100%',
            minHeight: '70%',
          }
        },
        transition: {
          onExited: () => {
            messaging.setSelectedConversationId(undefined);
            messaging.setFocusedMessageId(undefined);
          },
        }
      }}
    >
      {children}
    </Dialog>
  );
};


export const DesktopMessagingContent: React.FC<MessagingModalProps> = ({ color = 'secondary', ...props }) => {
  const messaging = useMessagingContext();
  const selectedConversation = useSelectedConversation();

  return (
    <>
      <MessagingDialogTitle title="Messages" />
      <Divider />
      <Box display="flex" height="100%" width="100%">
        <Box flex={1} maxWidth="360px">
          <ConversationsList
            selectedConversationId={messaging.selectedConversationId}
            setSelectedConversationId={messaging.setSelectedConversationId}
            onOpenToDosClick={props.onOpenToDosClick}
            color={color}
          />
        </Box>
        <Divider orientation="vertical" />
        <Messages conversation={selectedConversation} color={color} />
      </Box>
    </>
  );
};
